export default "__VITE_ASSET__Dxu1F$Ea__"